module.exports = __webpack_public_path__ + "media/src/images/icon/camera-6e20586fe90f72d5e670790b94ec3e08.png";